export default {
  data () {
    return {
      // 入力項目の判定を行っていい場合、ture（登録等のボタン押下時にtrueになる）
      isValidateCheck: false
    }
  },
  computed: {
    // 入力項目に問題がない場合、true
    // 各vueのvalidationに記載された変数をチェックする
    isValid () {
      const validation = this.validation
      return Object.keys(validation).every(key => {
        return !this.isValidateCheck || validation[key]
      })
    }
  },
  methods: {
    /**
     * 入力項目にエラーがある場合のクラスを返す
     * @param {string} key 入力項目のキー
     */
    errorClassObject (key) {
      return {
        'has-error': this.isValidateCheck && (this.validation[key] === false)
      }
    },
    /**
     * パスワードをチェックする
     * @param {string} password パスワード
     * @return 問題ない場合、true
     */
    checkPassword (password) {
      return (password.length >= 8) &&
        (password.length <= 99) &&
        /([A-Z])/.test(password) &&
        /([a-z])/.test(password) &&
        /([0-9])/.test(password)
    },
    /**
     * 配列内で重複しているかチェックする
     * @param {array} array 配列
     * @return 重複している場合、true
     */
    checkDuplicateArray (array) {
      const set = new Set(array)
      return set.size !== array.length
    }
  }
}
